// Maps vessel-inventory owner strings (often shorthand / inconsistent casing)
// to their formal customer name used on certificates and reports.
//
// Add new entries below. Keys should be the raw values users might type in
// the vessel inventory (lowercased, trimmed). Values should be the formal
// name exactly as it must appear on forms.
const OWNER_ALIAS_MAP = {
  'ne': 'Northern Energy',
  'n.e': 'Northern Energy',
  'n.e.': 'Northern Energy',
  'n/e': 'Northern Energy',
  'northern': 'Northern Energy',
  'northern energy': 'Northern Energy',
  'northern energy ltd': 'Northern Energy',
  'northern energy limited': 'Northern Energy',

  'midland': 'Midlands LPG',
  'midlands': 'Midlands LPG',
  'midland lpg': 'Midlands LPG',
  'midlands lpg': 'Midlands LPG',
  'midlands lpg ltd': 'Midlands LPG',
  'midlands lpg limited': 'Midlands LPG',
  'andy love': 'Midlands LPG',
  'andy loves': 'Midlands LPG',

  'bat': 'BATA',
  'bata': 'BATA',
  'bata ltd': 'BATA',
  'bata limited': 'BATA',

  'vit': 'Vita Gas',
  'vita': 'Vita Gas',
  'vita gas': 'Vita Gas',
  'vita gas ltd': 'Vita Gas',
  'vita gas limited': 'Vita Gas',

  'gauld': 'Gaulds Gas',
  'gauld gas': 'Gaulds Gas',
  'gaulds': 'Gaulds Gas',
  'gaulds gas': 'Gaulds Gas',
  'guld': 'Gaulds Gas',
  'guld gas': 'Gaulds Gas',
  'gald': 'Gaulds Gas',
  'gald gas': 'Gaulds Gas',

  'calor': 'Calor Gas',
  'calor gas': 'Calor Gas',
  'calor gas ltd': 'Calor Gas',
  'calor gas limited': 'Calor Gas'
};

const normaliseKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/\s+/g, ' ');

export const canonicaliseOwner = (value) => {
  if (!value) return '';
  const key = normaliseKey(value);
  if (!key) return '';
  if (OWNER_ALIAS_MAP[key]) return OWNER_ALIAS_MAP[key];

  // Also try with trailing punctuation stripped.
  const stripped = key.replace(/[.,/\\]+$/g, '').trim();
  if (stripped !== key && OWNER_ALIAS_MAP[stripped]) return OWNER_ALIAS_MAP[stripped];

  return String(value).trim();
};

export const hasCanonicalMatch = (value) => {
  if (!value) return false;
  const key = normaliseKey(value);
  return Object.prototype.hasOwnProperty.call(OWNER_ALIAS_MAP, key);
};

export default canonicaliseOwner;
